<template>
  <div>
    <template v-if="loader">
      <Loader />
    </template>
    <template v-if="deleteModal">
      <ModalDelete
        :invoice="invoiceSelected"
        @close="deleteModal=$event"
      />
    </template>
    <div
      class="line-table"
      :key="invoice.id"
    >
      <h2>{{ invoice.company_name }}</h2>
      <h2>{{ invoice.invoice_number }}</h2>
      <h2>{{ invoice.created_at | filterDate }}</h2>
      <template v-if="validAging(invoice.status)">
        <h2>{{ {actual:invoice.updated_at, old: invoice.created_at } | agingDate }}</h2>
      </template>
      <template v-else>
        <h2>{{ {actual:new Date(), old: invoice.created_at } | agingDate }}</h2>
      </template>
      <h2>{{ formatMoney(invoice.amount) }}</h2>
      <h2>{{ formatMoney(invoice.paid) }}</h2>
      <h2>
        <Status :status="invoice.status" />
      </h2>
      <h2>
        <template v-if="invoice.reference">
          {{ invoice.reference }}
        </template>
        <template v-else>N/A</template>
      </h2>
      <h2 class="divider">
        <div class="actions">
          <img
            @click="openAction()"
            :src="require('@/assets/icons/action-action.svg')"
            alt="actions"
          />
          <template v-if="!['Pending', 'INTEGRATED'].includes(invoice.status_integration)">
            <img
              @click="openAction()"
              class="warning"
              :src="require('@/assets/icons/warningIntegration.svg')"
              alt="warning"
            />
          </template>
          <div v-if="individualActions" class="individual-actions">
            <div class="act">
              <div @click="seeComment(invoice)" class="act-intern">
                <img
                  :src="require('@/assets/icons/comment-action.svg')"
                  alt="Comments for invoice"
                />
                <span>Invoice description</span>
              </div>
              <div class="act-intern">
                <template v-if="validPaid(invoice) === 0">
                  <Link :link="invoice.link" />
                </template>
              </div>
              <template
                v-if="(!cValidString)"
              >
                <div @click="deleteInvoice(invoice)" class="act-intern delete-invoice">
                  <img
                    :src="require('@/assets/icons/trash.svg')"
                    alt="Comments for invoice"
                  />
                  <span>Delete invoice</span>
                </div>
              </template>
              <template v-if="invoice.json_data_integration">
                <div class="act-intern" @click="integrate(invoice.id)">
                  <img
                    :src="require('@/assets/icons/action-refresh.svg')"
                    alt="Comments for invoice"
                  />
                  <span>Retry integration</span>
                </div>
              </template>
              <template v-if="invoice.json_import && invoice.status === 'Pending'">
                <div class="act-intern" @click="openPdf(invoice.json_import, invoice.link)">
                  <img
                    :src="require('@/assets/icons/pdf.svg')"
                    alt="PDF Invoice"
                  />
                  <span>PDF Invoice</span>
                </div>
              </template>
            </div>
          </div>
        </div>
      </h2>
    </div>
  </div>
</template>

<script>
import Link from '../Input/InputCopy.vue';
import Status from '../Status/PaymentStatus.vue';
import Loader from '../Loader/Loader.vue';
import ModalDelete from '../Modal/ModalDelete.vue';
import { downloadBlob } from '../../utils/downloadBlob';

export default {
  name: 'line-table-invoice',
  data() {
    return {
      loader: false,
      comment: false,
      individualActions: false,
      invoiceSelected: '',
      deleteModal: false,
    };
  },
  props: {
    invoice: [Object, Array],
  },
  components: {
    Link,
    Status,
    Loader,
    ModalDelete,
  },
  watch: {
    '$store.getters.value': function selected() {
      this.selected = false;
    },
  },
  computed: {
    cValidString() {
      if (this.invoice) {
        if (
          (this.invoice.status === 'AUTHORISED')
          || (this.invoice.status === 'Authorised')
          || (this.invoice.status === '[ test system ] AUTHORISED')
        ) {
          return true;
        }
      }
      return false;
    },
  },
  methods: {
    async openPdf(json, link) {
      const value = JSON.parse([json]);
      const transactionActual = { link };

      try {
        this.loader = true;
        const { data: response } = await this.$http.post('/v1/pdf-preview', { value, transactionActual }, { responseType: 'blob' });
        downloadBlob(response);
        this.loader = false;
      } catch (error) {
        console.error(error);
        this.loader = false;
      }
    },
    deleteInvoice(invoice) {
      this.deleteModal = true;
      this.invoiceSelected = invoice;
    },
    openAction() {
      console.log(this.invoice.json_data_integration);
      this.individualActions = !this.individualActions;
    },
    async integrate(id) {
      try {
        this.loader = true;
        const body = {
          id,
        };
        const headers = {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        };
        this.loaderTable = true;
        const { data: response } = await this.$http.post('/v1/quickbooks/force-integration', body, { headers });
        this.loader = false;
        if (response.integration === 'INTEGRATED') {
          this.$store.commit('OPEN_MODAL');
          this.$store.commit('UPDATE_MESSAGE', 'Successfully Integrated');
        } else {
          this.$store.commit('OPEN_MODAL');
          this.$store.commit('UPDATE_MESSAGE', response.integration);
        }
      } catch (error) {
        this.loader = false;
        this.$store.commit('OPEN_MODAL');
        this.$store.commit('UPDATE_MESSAGE', 'Try again');
      }
    },
    validAging(status) {
      const formated = this.formatStatusForTiny(status);
      if (formated.indexOf('authorised') !== -1) {
        return true;
      }
      return false;
    },
    formatMoney(value) {
      return value.toLocaleString('en-CA', { style: 'currency', currency: 'USD' });
    },
    seeComment(invoice) {
      const oldMessage = this.$store.getters.messageComment;
      this.$store.commit('UPDATE_MESSAGE_COMMENT', invoice.comment);
      this.$store.commit('UPDATE_REFERENCE_COMMENT', invoice.reference);
      if (this.$store.getters.openComment && (oldMessage === invoice.comment)) {
        this.$store.commit('CLOSE_COMMENT');
      } else {
        this.$store.commit('OPEN_COMMENT');
      }
    },
    validStatus(invoice) {
      return this.formatStatusForTiny(invoice.status).indexOf('authorised') === 0;
    },
    validPaid(invoice) {
      let value = 0;
      if (this.formatStatusForTiny(invoice.status).indexOf('authorised') !== -1) {
        value = invoice.amount;
        return value;
      }
      if (this.formatStatusForTiny(invoice.status).indexOf('authorised') === -1) {
        value = 0;
      }
      return value;
    },
    formatStatusForTiny(word) {
      return word.toLowerCase();
    },
  },
};
</script>
<style scoped lang="scss">
.act {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .act-intern {
    padding: 1px 0 1px 3px;
    margin: 1px 0;
    display: flex;
    align-items: center;
    cursor: pointer;
    span {
      margin-left: 8px;
      color: $header;
    }
    &:hover {
      border-radius: 4px;
      background-color: rgba(22, 32, 86, 0.2);
  }
  }
}
.actions {
  position: relative;
  .warning {
    position: absolute;
    bottom: 16px;
    left: 20px;
  }
}
.individual-actions {
  width:230px;
  max-height: fit-content;
  padding: 7px;
  position: absolute;
  background-color: $backgroundData;
  background-color: rgba(246, 246, 246, 0.9);
  border-radius: 5px;
  top: -30px;
  left: -230px;
  z-index: 5;
  box-shadow: 0px 0px 7px rgba(48, 48, 48, 0.25);

}
.line-table {
  display: flex;
  min-width: 1262px;
  justify-content: space-between;
  min-height: 65px;
  &:nth-child(odd) {
    background-color: $backgroundLineTable;
  }
  h2 {
    img {
      width: 25px;
      height: 25px;
    }
    font-weight: 500;
    font-size: 13.8355px;
    color: $dataTable;
    display: flex;
    align-items: center;
    margin-right: 45px;
    white-space: nowrap;
    text-align: left;
    @media (min-width: 1440px) {
      margin-right: 0px !important;
    }
    img {
      cursor: pointer;
    }
    &:nth-child(1) {
      white-space: normal;
      padding-left: 29px;
      margin-right: 75px;
      min-width: 127px;
      max-width: 127px;
      @media (min-width: 1440px) {
        margin-right: 0px;
      }
    }
    &:nth-child(2) {
      min-width: 65px;
    }
    &:nth-child(3) {
      min-width: 79px;
    }
    &:nth-child(4) {
      min-width: 44px;
    }
    &:nth-child(5) {
      min-width: 110px;
    }
    &:nth-child(6) {
      min-width: 90px;
    }
    &:nth-child(7) {
      min-width: 140px;
    }
    &:nth-child(8) {
      min-width: 120px;
      max-width: 120px;
      white-space: normal;
    }
    &:nth-child(9) {
      display: flex;
      justify-content: center;
      min-width: 80px;
    }
    @media (min-width: 1440px) {
      &:nth-child(1) {
        white-space: normal;
        padding-left: 29px;
        min-width: 10%;
        max-width: 10%;
      }
      &:nth-child(2) {
        min-width: 10%;
      }
      &:nth-child(3) {
        min-width: 10%;
      }
      &:nth-child(4) {
        min-width: 10%;
      }
      &:nth-child(5) {
        min-width: 10%;
      }
      &:nth-child(6) {
        min-width: 10%;
      }
      &:nth-child(7) {
        min-width: 10%;
      }
      &:nth-child(8) {
        min-width: 10%;
        max-width: 10%;
        white-space: normal;
      }
      &:nth-child(9) {
        display: flex;
        justify-content: center;
        min-width: 10%;
      }
    }
  }
}
.delete-invoice {
  border-radius: 4px;
  transition: .2s ease-in-out;
  &:hover {
    background-color: rgba(210, 0, 0, 0.5)!important;
  }
}
</style>
